// extracted by mini-css-extract-plugin
module.exports = {"basic-table":"_3JM62"};